import { useState } from "react"
import { Currency } from "@/types/types"
import SearchItem from "./SearchItem"

const SearchForm = ({
  currencies,
  onSelect,
}: {
  currencies: Currency[]
  onSelect: ({
    currency,
    threshold,
  }: {
    currency: Currency
    threshold: number
  }) => Promise<void>
}) => {
  const [query, setQuery] = useState("")

  const displayCurrencies = currencies
    .filter(
      (c) =>
        c.name.toLowerCase().includes(query.toLowerCase()) ||
        c.symbol.toLowerCase().startsWith(query.toLowerCase())
    )
    .slice(0, 10)

  return (
    <div className="flex flex-1 flex-col">
      <div className="mb-1 h-10 flex-none">
        <input
          type="text"
          className="w-full rounded-lg border-none bg-transparent py-2 text-center text-base placeholder-gray-600 outline-none focus-visible:bg-gray-800"
          autoFocus
          autoComplete="off"
          autoCorrect="off"
          autoCapitalize="off"
          spellCheck="false"
          placeholder="Search currencies…"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
      </div>
      {displayCurrencies.length > 0 ? (
        <div className="flex flex-1 flex-col space-y-1">
          {displayCurrencies.map((currency) => (
            <SearchItem
              key={currency.id}
              currency={currency}
              onSelect={onSelect}
            />
          ))}
        </div>
      ) : (
        <div className="mb-1 flex h-16 items-center justify-center rounded-lg border border-dashed border-gray-700 text-gray-500">
          No matching currencies
        </div>
      )}
    </div>
  )
}

export default SearchForm
